import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	backButtonNonFinal: {
		id: 'eoc-changeboarding.transition-home.back-button-non-final',
		defaultMessage: 'Back',
		description: 'Back button text',
	},
	closeButtonNonFinal: {
		id: 'eoc-changeboarding.transition-home.close-button-non-final',
		defaultMessage: 'Close',
		description: 'Close button text for transitioning home',
	},
	minimizeNonFinal: {
		id: 'eoc-changeboarding.transition-home.minimize-non-final',
		defaultMessage: 'Minimize',
		description: 'Label of minimize icon',
	},
	giveFeedbackButtonNonFinal: {
		id: 'eoc-changeboarding.transition-home.give-feedback-button-non-final',
		defaultMessage: 'Give feedback',
		description: 'Label of Feedback icon',
	},
});
